import { AccountingZipRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";

class XmlsPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false
    };
  }
  async onDownloadButton(month, year) {
    this.enqueue({ loading: true });
    const result = await AccountingZipRepository.fetch(month, year);
    this.enqueue({ loading: false });
    if (result.success) {
      return window.open(result.data.url, "_blank");
    } else {
      this.sendNotification({
        type: "error",
        title: "Ooops...",
        content: "Houve um erro, tente novamente em alguns minutos."
      });
    }
  }
}

export default XmlsPresenter;



// WEBPACK FOOTER //
// ./src/components/app/history/xmls/xmls.presenter.js